{
  "display_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Company",
      "width": 240
    }
  },
  "is_public": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is Public"
    }
  },
  "gross_oil_equivalent_boe_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "Gross Licenced Production",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_oil_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Oil",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_condensate_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Condensate",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_natural_gas_mmcf_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mmcf/d"
    },
    "ui": {
      "label": "Gross Natural Gas",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_c2c3c4_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross C2+C3+C4",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_c5_cond_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross C5+Condensate",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "percent_change_six_months_boe_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "%"
    },
    "ui": {
      "label": "Gross Change in Production 6mo",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_liquid_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Liquid",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_water_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Water",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_water_injection_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Water Injection",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_ethane_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Ethane",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_propane_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Propane",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_butane_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Butane",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_pentane_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Pentane",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "gross_production_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Gross Production Date",
      "isShownByDefault": true
    }
  },
  "well_licenses_count": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "# total"
    },
    "ui": {
      "label": "Well Licences",
      "isShownByDefault": true
    }
  },
  "producing_wells_count": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "# total"
    },
    "ui": {
      "label": "Producing Wells",
      "isShownByDefault": true
    }
  },
  "active_status_wells_count": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "# total"
    },
    "ui": {
      "label": "Active Status Wells",
      "isShownByDefault": true
    }
  },
  "suspended_wells_count": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "# total"
    },
    "ui": {
      "label": "Suspended Wells Count",
      "isShownByDefault": true
    }
  },
  "well_licenses_issued_last_three_months_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Well Licenses Issued Last 3mo Count",
      "isShownByDefault": true
    }
  },
  "well_licenses_issued_last_twelve_months_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Well Licenses Issued Last 12mo Count",
      "isShownByDefault": true
    }
  },
  "well_licenses_spudded_last_three_months_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Well Licenses Spudded Last 3mo Count",
      "isShownByDefault": true
    }
  },
  "well_licenses_spudded_last_twelve_months_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Well Licenses Spudded Last 12mo Count",
      "isShownByDefault": true
    }
  },
  "company_brand_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Company Brand ID"
    }
  },
  "injection_wells_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Injection Wells Count",
      "isShownByDefault": true
    }
  },
  "abandoned_wells_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Abandoned Wells Count",
      "isShownByDefault": true
    }
  },
  "oil_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Corporate Oil",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "natural_gas_mmcf_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mmcf/d"
    },
    "ui": {
      "label": "Corporate Gas",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "condensate_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Corporate Condensate",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "ngl_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Corporate NGL",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "liquid_productions_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Corporate Liquids",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "oil_equivalent_boe_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "Corporate Oil Equivalent",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "percent_of_production_as_liquids": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "%"
    },
    "ui": {
      "label": "Percent of Production as Liquids"
    }
  },
  "g_and_a": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe"
    },
    "ui": {
      "label": "G&A"
    }
  },
  "operating_expense_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Operating Expense",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "netback_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Netback"
    }
  },
  "transportation_costs_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe"
    },
    "ui": {
      "label": "Transportation Costs"
    }
  },
  "royalty_cost_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe"
    },
    "ui": {
      "label": "Royalty Cost"
    }
  },
  "hedging_gain_loss_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe"
    },
    "ui": {
      "label": "Hedging Gain/Loss"
    }
  },
  "financing_costs_cad_per_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Financing Costs"
    }
  },
  "share_based_compensation_cad_per_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Share Based Compensation"
    }
  },
  "net_debt_mda_cad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "CAD"
    },
    "ui": {
      "label": "Net Debt MDA"
    }
  },
  "net_debt_formula_cad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "CAD"
    },
    "ui": {
      "label": "Net Debt Formula"
    }
  },
  "operating_cash_flow_cad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "CAD"
    },
    "ui": {
      "label": "Operating Cash Flow"
    }
  },
  "capex_cad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "CAD"
    },
    "ui": {
      "label": "Capex"
    }
  },
  "oil_realized_price_cad_per_bbl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/bbl",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Oil Realized Price"
    }
  },
  "natural_gas_realized_price_cad_per_mcf": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/mcf"
    },
    "ui": {
      "label": "Gas Realized Price"
    }
  },
  "condensate_realized_price_cad_per_bbl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/bbl",
      "fractionDigits": 2
    },
    "ui": {
      "label": "Condensate Realized Price"
    }
  },
  "ngl_realized_price_cad_per_bbl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/bbl"
    },
    "ui": {
      "label": "NGL Realized Price"
    }
  },
  "oil_equivalent_realized_price_cad_per_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe"
    },
    "ui": {
      "label": "Oil Equivalent Realized Price"
    }
  },
  "dividends_paid_mcad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$mil"
    },
    "ui": {
      "label": "Dividends Paid"
    }
  },
  "decommissioning_obligations_mcad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$mil"
    },
    "ui": {
      "label": "Decommissioning Obligations"
    }
  },
  "share_buybacks_mcad": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$mil"
    },
    "ui": {
      "label": "Share Buybacks"
    }
  },
  "d_and_d_cad_per_boe": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe"
    },
    "ui": {
      "label": "D&D"
    }
  },
  "year_and_quarter": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Year & Quarter"
    }
  },
  "market_capitalization": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$"
    },
    "ui": {
      "label": "Market Capitalization"
    }
  },
  "net_debt": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$"
    },
    "ui": {
      "label": "Net Debt"
    }
  },
  "enterprise_value_ev": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$"
    },
    "ui": {
      "label": "Enterprise Value"
    }
  },
  "cash_from_operations": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$"
    },
    "ui": {
      "label": "Cash from Operations"
    }
  },
  "positive_capital_expenditure": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$"
    },
    "ui": {
      "label": "Capital Expenditure"
    }
  },
  "enterprise_value_per_boe_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "$/boe/d"
    },
    "ui": {
      "label": "EV/BOE/d"
    }
  },
  "ev_over_ltmocf": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "x",
      "displaySymbol": true,
      "fractionDigits": 1
    },
    "ui": {
      "label": "EV/LTMOCF"
    }
  },
  "wellbore_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Producing Wellbore Count"
    }
  },
  "license_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Producing License Count"
    }
  },
  "gross_oil_equivalent_boe_d_per_producing_well": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d/well"
    },
    "ui": {
      "label": "Gross Oil Equivalent per Producing Well"
    }
  }
}